export enum StateOrderIdentification {
  PendenteRegistroOmie = 1,
  PedidoSeparado = 90,
  AguardandoSeparacao = 7,
  AguardandoFaturamento = 9,
  NFImpressa = 10,
  AguardandoPacking = 11,
  ProntoParaEnvio = 12,
  Enviado = 13,
  AguardandoCliente = 17,
  AguardandoArmacao = 18,
  AguardandoCorrecao = 19,
  ErroNaSeparacao = 20,
  ProblemaNaArmacao = 21,
  Cancelado = 22,
  EmColeta = 30,
  EmTransporte = 40,
  EmTransporteAlertaInterno = 41,
  EmTransporteAlertaInternoExterno = 42,
  Entregue = 50,
  NaoEntregueAlertaInterno = 61,
  NaoEntregueAlertaInternoExterno = 62,
  NaoEntregueOK = 70,
  PendenteVendedor = 71,
  EstoqueGlobalFaltaCobertura = 82,
  EstoqueGlobalCoberturaOK = 83,
  PedidoRecebidoMontagem = 91,
  PedidoFaturando = 200,
  PedidoFaturado = 201
}